import {useState, useMemo} from 'react'

import {KpiTabValuesDto} from '../types'

export const useSelectedSlaKpi = (data: KpiTabValuesDto) => {
  const [selectedKpiValueId, setSelectedKpiValueId] = useState<string | undefined>()

  const selectedKpiDefinition = useMemo(() => {
    return data.kpiDefinitions.find((kpi) =>
      kpi.kpiValues.some((value) => value.id === selectedKpiValueId)
    )
  }, [data.kpiDefinitions, selectedKpiValueId])

  const selectedKpiValue = useMemo(() => {
    return selectedKpiDefinition?.kpiValues.find((value) => value.id === selectedKpiValueId)
  }, [selectedKpiDefinition, selectedKpiValueId])

  return {
    selectedKpiValueId,
    setSelectedKpiValueId,
    selectedKpiDefinition,
    selectedKpiValue
  }
}
